import { render, staticRenderFns } from "./istio.vue?vue&type=template&id=66dea0ab&"
import script from "./istio.vue?vue&type=script&lang=js&"
export * from "./istio.vue?vue&type=script&lang=js&"
import style0 from "./istio.vue?vue&type=style&index=0&id=66dea0ab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports